// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { textOverflowEllipsis } from "@eisinc/App/SharedStyles/GeneralStyles";
import { myListsDetailsOptionsStyles } from "@eisinc/Overrides/Widgets/MyListsDetails/MyListsDetailsOptions";
import Search from "@eisinc/XDL/Icons/Search";
import { xScreen } from "@eisinc/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import ChevronsUpDown from "@insite/mobius/Icons/ChevronsUpDown";
import X from "@insite/mobius/Icons/X";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

myListsDetailsOptionsStyles.wrapper = {
    css: css`
        @media print {
            display: none;
        }
        display: flex;
        padding: 25px 0;
        justify-content: center;
        position: relative;
    `,
};

myListsDetailsOptionsStyles.leftColumnWrapper = {
    css: css`
        display: flex;
        width: calc(100% - 40px);
        &.addItemsOn {
            width: 100%;
        }
    `,
};

myListsDetailsOptionsStyles.rightColumnWrapper = {
    css: css`
        display: flex;
        width: 40px;
        justify-content: center;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    position: absolute;
                    top: 15px;
                    right: 10px;
                `,
                css`
                    position: absolute;
                    top: 15px;
                    right: 10px;
                `,
                css`
                    align-items: center;
                `,
                css`
                    align-items: center;
                `,
                css`
                    align-items: center;
                `,
            ])}
    `,
};

myListsDetailsOptionsStyles.selectAllGridItem = {
    width: [12, 12, 6, 4, 3],
    css: css`
        align-items: center;
        > div:first-child {
            margin-right: 30px;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    justify-content: space-between;
                `,
                css`
                    justify-content: space-between;
                `,
                null,
                null,
                null,
            ])}
    `,
};

myListsDetailsOptionsStyles.selectAll = {};

myListsDetailsOptionsStyles.editSortOrder = {};

myListsDetailsOptionsStyles.addItemsGridItem = {
    width: [12, 12, 6, 4, 5],
    css: css`
        align-items: center;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css``,
                css``,
                css``,
                css`
                    justify-content: flex-end;
                `,
                css`
                    justify-content: flex-end;
                `,
            ])}
    `,
};

myListsDetailsOptionsStyles.productSelectorGridItem = { width: [12, 12, 12, 10, 10] };

myListsDetailsOptionsStyles.uploadItemsGridItem = {
    width: [12, 12, 12, 2, 2],
    css: css`
        align-items: center;
        justify-content: center;
    `,
};

myListsDetailsOptionsStyles.uploadItemsLink = {
    css: css`
        margin-top: 18px;
        ${xScreen("lte", "md")} {
            margin-top: 0;
        }
    `,
};

myListsDetailsOptionsStyles.search = {
    iconProps: { src: Search },
    cssOverrides: {
        formField: css`
            input {
                padding-right: 28px !important;
                ${textOverflowEllipsis};
            }
        `,
    },
};

myListsDetailsOptionsStyles.sortByOverflowMenu = {
    iconProps: { src: ChevronsUpDown },
    cssOverrides: {
        wrapper: css`
            width: 100%;
            max-width: 30px;
            margin-top: 7px;
            margin-right: 5px;
        `,
    },
    buttonProps: {
        variant: "secondary",
        css: css`
            max-width: 100%;
        `,
    },
};

myListsDetailsOptionsStyles.closeAddItemsToList = {
    src: X,
    css: css`
        cursor: pointer;
        align-items: flex-start;
        margin-top: 18px;
        ${xScreen("lte", "md")} {
            margin-top: 0;
        }
    `,
};

myListsDetailsOptionsStyles.searchGridItem = {
    width: [12, 12, 6, 4, 4],
    css: css`
        align-items: center;
    `,
};
